import React, { useState } from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,MDBIcon
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import MultiView from './MutiView';



    const MultiViewModal = ({ isReceiptToBeViewed, setIsReceiptToBeViewed, companyName, setShowAlert}) => {
  

  const toggleOpen = () => setIsReceiptToBeViewed(!isReceiptToBeViewed);

  return (
    

      <MDBModal tabIndex='-1' open={isReceiptToBeViewed} setOpen={setIsReceiptToBeViewed} >
        <MDBModalDialog centered={true} size='fullscreen'>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle className='text-center'>Processed Receipts</MDBModalTitle>
              <MDBBtn className='btn-close me-2' color='none' onClick={toggleOpen}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <MultiView setIsReceiptToBeViewed={setIsReceiptToBeViewed} companyFromModal={companyName} setShowAlertForProcessed={setShowAlert}/>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn className='btn-close me-2' color='none' onClick={toggleOpen}> </MDBBtn>
              
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
 
  );
}

MultiViewModal.propTypes = {
    isReceiptToBeViewed: PropTypes.bool,
    setShowAlert: PropTypes.func,
    setIsReceiptToBeViewed: PropTypes.func,
  companyName: PropTypes.string,
  };
   
  export default MultiViewModal;